/**
 * Application Constants
 * Centralized place for version numbers and asset versioning
 * 
 * HOW TO UPDATE IMAGES AND VIDEOS:
 * =================================
 * When you update any of these assets in the public folder:
 * 1. Replace the file in /public/ (keep the same filename)
 * 2. Increment the corresponding version number below (e.g., '1.0.0' -> '1.0.1')
 * 3. Rebuild and redeploy the site
 * 
 * The version query parameter (?v=1.0.1) forces browsers to fetch the new asset
 * instead of using their cached version.
 * 
 * IMPORTANT: For large files like videos, incrementing the version also tells the
 * deployment script to re-upload the file to S3. If the version hasn't changed,
 * the deployment will skip uploading to save time and bandwidth.
 * 
 * Assets in /public/ folder:
 * - Solidly Finance App.png            -> HERO_IMAGE
 * - og-image.jpg                       -> OG_IMAGE (Facebook/LinkedIn share preview)
 * - twitter-image.jpg                  -> TWITTER_IMAGE (Twitter share preview)
 * - Solidly Finance Launch Video.mp4   -> DEMO_VIDEO (main demo video)
 * - solidly-finance-poster.jpg         -> VIDEO_POSTER (video thumbnail/poster)
 */

// Asset versions for cache busting
// Increment these when you update the corresponding assets
export const ASSET_VERSIONS = {
  HERO_IMAGE: '1.0.2',      // Main hero screenshot on homepage
  OG_IMAGE: '1.0.0',        // Open Graph image for social sharing
  TWITTER_IMAGE: '1.0.0',   // Twitter card image
  DEMO_VIDEO: '1.0.0',      // Demo video in /public/ folder (Solidly Finance Launch Video.mp4)
  VIDEO_POSTER: '1.0.0',    // Video poster image (solidly-finance-poster.jpg)
};

// Helper function to get versioned asset URL
export const getVersionedAsset = (path, version = null) => {
  if (version) {
    return `${path}?v=${version}`;
  }
  return path;
};
